<template>
  <div class="hotsale clearfix">
    <el-card :body-style="{padding:'0px'}" shadow="hover" :key="index" v-for="(item,index) in hotsaleItems" v-if="index<6" :class="index==0||index==3?'':'mgin'">
      <router-link :to="{path:'estateDetail?estateId='+item.pkId}"><img v-lazy="item.path+'&type=1&size=375x240'" /></router-link>
      <span class="hslocal" v-if="!isPC">{{item.stName}}</span>
      <div class="hsdesc">
        <p class="hstitle"><router-link :to="{path:'estateDetail?estateId='+item.pkId}">
          <span v-if="isPC">[{{item.stName}}-{{item.scName}}]</span>{{item.name}}
        </router-link></p>
        <span class="hsarea">{{item.acreage}}</span>
        <span class="mprice" v-if="item.price!=null&&item.price!=0"><b>{{item.price}}</b>{{item.priceUnit}}</span>
        <span class="mprice" v-else>售价待定</span>
      </div>
    </el-card>
    <div class="noitem" v-if="hotsaleItems.length==0"><span>{{msg}}</span></div>
  </div>
</template>

<script>
export default {
  name: 'HotSale',
  props:{
    isPC:Boolean
  },
  data () {
    return {
      hotsaleItems:[],
      msg:'正在加载...'
    }
  },
  mounted(){
    var _this = this;
    _this.getHot();
  },
  methods:{
    getHot:function(){
      this.$http.get('/api/baidu/getHotEstateList').then((response)=>{
        this.hotsaleItems = response.data.result;
        this.msg='暂无数据'
      }).catch((response)=>{
        console.log(response)
      })
    }
  }
}
</script>

<style scoped>
.el-card{margin-top:24px;width:32%;float:left;box-sizing:border-box;position:relative;}
.el-card.mgin{margin-left:2%;}
.el-card img{display:block;width:100%;height:240px;}
.hsdesc{padding:20px;line-height:20px;}
.hsdesc a:hover{text-decoration:underline;}
.hstitle{font-size:16px;margin-bottom:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.hslocal{position:absolute;left:0;top:5px;line-height:20px;font-size:12px;background:#ffd03d;padding:0 8px 0 4px;border-top-right-radius:10px;border-bottom-right-radius:10px;}
.hsarea{background:rgba(255,208,61,0.25);color:#b0740c;padding:0 15px;border-radius:10px;display:inline-block;margin-right:10px}


@media (min-width:769px){
  .el-card{height:270px;padding-top:180px;}
  .el-card img{position:absolute;left:0;top:0;height:180px;}
  .hsarea{padding:2px 15px 1px;}
  .mprice{display:inline-block;float:right;}
}
@media (min-width:900px){
  .el-card{height:290px;padding-top:200px;}
  .el-card img{height:200px;}
}
@media (min-width:1000px){
  .el-card{height:330px;padding-top:240px;}
  .el-card img{height:240px;}
}
@media (max-width:768px){
  .hotsale{padding-top:5px;}
  .el-card{box-shadow:0 2px 12px 0 rgba(0,0,0,.1);margin-top:15px;}
  .el-card img{height:150px;}
  .hsdesc{padding:5px;text-align:center;}
  .hstitle{font-size:15px;margin-bottom:2px;}
  .mprice{display:block;}
  .hsarea{font-size:12px;margin-right:0;margin-bottom:4px;padding:0 10px;}
}
@media (max-width:640px){
  .el-card{margin-top:10px;}
  .el-card img{height:120px;}
}
@media (max-width:540px){
  .el-card img{height:100px;}
}
@media (max-width:420px){
  .el-card{margin-top:7px;}
  .el-card img{height:80px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/HotSale.vue